import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import { NavLink, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'store/store';
import { login, logout } from 'features/authSlice';
import qualityCheckApi from 'store/apis/qualityCheckApi';
import { useEffect, useState } from 'react';
import { Menu, MenuItem, Button, ButtonBase, IconButton, Stack, Tooltip } from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import LogoutIcon from '@mui/icons-material/Logout';
import MenuIcon from '@mui/icons-material/Menu';
import { useTranslation } from 'react-i18next';
import LanguageSwitch from './LanguageSwitch';
import axios from 'axios';

type AppbarProps = {
    toggleSideBar: () => void;
};

const Appbar = (props: AppbarProps) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const isLoggedIn = useSelector((state: RootState) => state.auth.isLoggedIn);
    const { data: user, isSuccess, isError, isLoading, refetch } = qualityCheckApi.useQualityCheckJobUserProfileQuery();

    const [usage, setUsage] = useState({ callFigure: 0, glossaryCheck: 0, sumCheck: 0, glossaryExtract: 0 });

    const [anchorElUser, setAnchorElUser] = useState<null | HTMLElement>(null);

    useEffect(() => {
        if (isSuccess) {
            dispatch(login(user))
            const callFigureUsage = user?.usage.callFigure.sourceWordCount;
            const glossaryCheckUsage = user?.usage.glossaryCheck.sourceWordCount;
            const sumCheckUsage = user?.usage.sumCheck.numberCount;
            const glossaryExtractUsage = user?.usage.glossaryExtract.sourceWordCount + user?.usage.glossaryExtract.targetWordCount;
            setUsage({
                callFigure: callFigureUsage,
                glossaryCheck: glossaryCheckUsage,
                sumCheck: sumCheckUsage,
                glossaryExtract: glossaryExtractUsage
            })
        }
        if (isError) {
            dispatch(logout())
        }
    }, [isLoading])

    // const handleLogout = () => {
    //     setAnchorElUser(null);
    //     refetch();
    //     axios.post("/logout", null)
    //         .then(response => {
    //             if (response.status === 200) {
    //                 dispatch(logout());
    //             }
    //         })
    //         .catch((error) => { })
    // };

    const handleMenuItemOnClick = (destination: String) => {
        setAnchorElUser(null);
        navigate(`/${destination}`)
    }

    // const renderMenu = (
    //     <Menu
    //         sx={{ mt: '45px', paddingTop: "0px", paddingBottom: "0px" }}
    //         id="menu-appbar"
    //         anchorEl={anchorElUser}
    //         anchorOrigin={{
    //             vertical: 'top',
    //             horizontal: 'right',
    //         }}
    //         keepMounted
    //         transformOrigin={{
    //             vertical: 'top',
    //             horizontal: 'right',
    //         }}
    //         open={Boolean(anchorElUser)}
    //         onClose={() => setAnchorElUser(null)}
    //     >
    //         <MenuItem
    //             onClick={() => handleMenuItemOnClick("profile")}
    //             divider
    //         >
    //             <Typography textAlign="center">Profile</Typography>
    //         </MenuItem>
    //         <MenuItem
    //             onClick={() => handleMenuItemOnClick("my-document")}
    //         >
    //             <Typography textAlign="center">Document</Typography>
    //         </MenuItem>

    //     </Menu>
    // )

    return (
        <AppBar position="fixed" style={{ backgroundColor: 'white', borderBottom: '1px solid RGB(0,0,0,0.12)', top: '0px' }} elevation={0}>
            <Toolbar sx={{ height: 58, minHeight: 58 }}>
                <IconButton onClick={props.toggleSideBar} edge="start" sx={{ mr: '5px' }}>
                    <MenuIcon sx={{ color: 'black' }} />
                </IconButton>
                <Box sx={{ display: 'flex' }}>
                    <NavLink className="topnav__logo-navlink" to="/">
                        <Typography
                            variant="h6"
                            color={"black"}
                            letterSpacing={"0.3rem"}
                        >
                            {"A"}
                            <span style={{ color: "darkgreen" }}>
                                {"DD"}
                            </span>
                            {"CURACY"}
                        </Typography>
                    </NavLink>
                </Box>
                <Box flexGrow={1} />
                <Box sx={{ mr: 2, display: 'flex', alignItems: 'center' }}>
                    <LanguageSwitch />
                </Box>
                <Box sx={{ display: 'flex' }}>
                    {isLoggedIn && (
                        <Box sx={{ display: 'flex', alignItems: 'center', flexDirection: 'column-reverse' }}>
                            <Tooltip
                                title={
                                    <>
                                        {t('common.callfigure')}: {usage.callFigure} <br />
                                        {t('common.glossaryCheck')}: {usage.glossaryCheck} <br />
                                        {t('common.sumCheck')}: {usage.sumCheck} <br />
                                        {t('common.glossaryExtract')}: {usage.glossaryExtract}
                                    </>
                                }
                            >
                                <Box>
                                    <Typography color={'black'}>
                                        {t('common.monthlyUsage') + ': ' + (usage.callFigure + usage.glossaryCheck + usage.sumCheck + usage.glossaryExtract)}
                                    </Typography>
                                </Box>
                            </Tooltip>
                            <Button onClick={() => handleMenuItemOnClick('my-document')}>{t('common.myDocument')}</Button>
                            {/* <ButtonBase onClick={(event) => { setAnchorElUser(event.currentTarget) }}>
                                <MoreVertIcon sx={{ color: "black" }} />
                            </ButtonBase>
                            {renderMenu} */}
                        </Box>
                    )}
                    {/* {isLoggedIn &&
                    <Box sx={{ display: 'flex' }}>
                        <Box>
                            <Typography color={"black"}>
                                {"Credit: " + user?.creditBalance}
                            </Typography>
                        </Box>
                        <ButtonBase onClick={(event) => { setAnchorElUser(event.currentTarget) }}>
                            <MoreVertIcon sx={{ color: "black" }} />
                        </ButtonBase>
                        {renderMenu}
                        <ButtonBase onClick={handleLogout}>
                            <LogoutIcon
                                sx={{ color: "black" }}
                            />
                        </ButtonBase>
                    </Box>
                } */}
                    {/* {!isLoggedIn &&
                    <Box sx={{ display: 'flex' }}>
                        <Button onClick={() => navigate("/login")}>
                            Sign In
                        </Button>
                    </Box>
                } */}
                </Box>
            </Toolbar>
        </AppBar>
    );
};

export default Appbar;
